import { LazyAction, LazyModule } from 'owa-bundling-light';
export * from './utils/loadEmailSignaturePreferences';
export * from './utils/isSignatureEnabled';
export * from './cache/emailSignatureCache';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "SignaturePreference", webpackPrefetch: true */ './lazyIndex')
);

export const lazyLoadEmailSignaturePreferences = new LazyAction(
    lazyModule,
    m => m.loadEmailSignaturePreferences
);
